<div id="home-feed-wrapper" class="responsive two-col home-feed" [brightsideWebFb]="{ event_name: 'feed_shown'}">
  <div>
    <section [ngClass]="{ 'no-content': !sectionVisibility[_homeFeedSection.URGENT_NOTIFICATIONS] }">
      <brightside-web-home-feed-section [sectionTitle]="'SERVICE_ALERT_TITLE' | translate">
        <ng-container #urgentNotificationsContainer></ng-container>
      </brightside-web-home-feed-section>
    </section>
    <section [ngClass]="{ 'no-content': !sectionVisibility[_homeFeedSection.PROMOTION] }">
      <brightside-web-home-feed-section>
        <bw-carousel-wrapper-legacy [totalItems]="sectionCount[_homeFeedSection.PROMOTION]">
          <ng-container #promotionContainer></ng-container>
        </bw-carousel-wrapper-legacy>
      </brightside-web-home-feed-section>
    </section>
    <section [ngClass]="{ 'no-content': !sectionVisibility[_homeFeedSection.ACTIONS] }">
      <brightside-web-home-feed-section [sectionTitle]="'YOUR_ACTIONS_SECTION' | translate">
        <ng-container #actionsContainer></ng-container>
      </brightside-web-home-feed-section>
    </section>
    <section [ngClass]="{ 'no-content': !sectionVisibility[_homeFeedSection.PROGRAMS] }">
      <brightside-web-home-feed-section [sectionTitle]="'EMPLOYER_PROGRAMS' | translate">
        <ng-container #programsContainer></ng-container>
      </brightside-web-home-feed-section>
    </section>
    <section>
      <brightside-web-home-feed-section
        [sectionTitle]="'FIND_MONEY_SECTION' | translate"
        [showLoading]="!sectionVisibility[_homeFeedSection.FINDMONEY]"
      >
        <ng-container #findMoneyContainer> </ng-container>
      </brightside-web-home-feed-section>
    </section>
  </div>
  <div>
    <section>
      <brightside-web-home-feed-section [sectionTitle]="'MY_MONEY' | translate">
        <section class="my-money-section" [ngClass]="{ 'no-content': !sectionVisibility[_homeFeedSection.MYMONEYINFO] }">
          <ng-container #myMoneyInfoContainer></ng-container>
        </section>
        <section class="my-money-section" [ngClass]="{ 'no-content': !sectionVisibility[_homeFeedSection.MYMONEYCOMPLETE] }">
          <ng-container #myMoneyCompleteContainer></ng-container>
        </section>
        <section class="my-money-section" [ngClass]="{ 'no-content': !sectionVisibility[_homeFeedSection.MYMONEYINITIAL] }">
          <typography-legacy text-small-semibold>{{ 'FINANCIAL_TOOLS' | translate }}</typography-legacy>
          <ng-container #myMoneyInitialContainer></ng-container>
        </section>
        <section
          class="pay-day-section"
          [ngClass]="{
            'no-content': !sectionVisibility[_homeFeedSection.PAYDAY],
            'pay-day-section--alone':
              !sectionVisibility[_homeFeedSection.REPAYMENTS] && !sectionVisibility[_homeFeedSection.MYMONEYHELP]
          }"
        >
          <ng-container #payDayContainer></ng-container>
        </section>
        <section
          class="my-money-section home-feed__repayments"
          [ngClass]="{
            'no-content': !sectionVisibility[_homeFeedSection.REPAYMENTS],
            'has-pay-day-section': !!sectionVisibility[_homeFeedSection.PAYDAY]
          }"
        >
          <typography-legacy text-small-semibold>{{ 'REPAYMENTS' | translate }}</typography-legacy>
          <ng-container #repaymentsContainer></ng-container>
        </section>
        <section
          class="my-money-section home-feed__my-money-money-help"
          [ngClass]="{
            'no-content': !sectionVisibility[_homeFeedSection.MYMONEYHELP],
            'has-pay-day-section': !!sectionVisibility[_homeFeedSection.PAYDAY] && !sectionVisibility[_homeFeedSection.REPAYMENTS]
          }"
        >
          <typography-legacy text-small-semibold>{{ 'MONEY_HELP' | translate }}</typography-legacy>
          <ng-container #myMoneyHelpContainer></ng-container>
        </section>
      </brightside-web-home-feed-section>
    </section>
  </div>
</div>
